<template>
    <div>
        <div class="form-box mb10">
            <el-form inline :model="queryData" size="mini" ref="formInline">
                <el-form-item>
                    <CustomInput  label='规则ID'>
                        <ESelect
                            v-model="queryData.id"
                            filterable
                            clearable
                            placeholder="请输入规则ID"
                            multiple
                            collapse-tags
                            remote
                            reserve-keyword
                            :loading="searchLoading"
                            :remote-method="(search) => getSearchList(search, 'ruleOptions')"
                        >
                            <p class="option-select">
                                <el-button type="text" @click="()=>handleSelectAll(ruleOptions, 'id', 'all')">全选</el-button>
                                <el-button type="text" @click="()=>handleSelectAll(ruleOptions, 'id', 'cancel')">取消全选</el-button>
                            </p>
                            <el-option
                                v-for="item in ruleOptions"
                                :key="item"
                                :label="item"
                                :value="item"
                            />
                        </ESelect>
                    </CustomInput>
                </el-form-item>

                <el-form-item>
                    <CustomInput  label='媒体'>
                        <ESelect
                            v-model="queryData.plat_id"
                            @change="changePlat"
                            filterable
                            clearable
                            placeholder="请选择">
                            <el-option
                                v-for="item in platList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            />
                        </ESelect>
                    </CustomInput>
                </el-form-item>
                <el-form-item>
                    <CustomInput  label='投放场景'>
                        <ESelect
                            v-model="queryData.delivery_scene"
                            @change="changeDeliveryScene"
                            filterable
                            clearable
                            placeholder="请选择">
                            <el-option
                                v-for="item in deliverySceneList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            />
                        </ESelect>
                    </CustomInput>
                </el-form-item>
                <el-form-item>
                    <CustomInput  label='投放版位'>
                        <ESelect
                            v-model="queryData.delivery_type"
                            filterable
                            clearable
                            placeholder="请选择">
                            <el-option
                                v-for="item in deliveryTypeList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            />
                        </ESelect>
                    </CustomInput>
                </el-form-item>
                <el-form-item>
                    <CustomInput label='素材尺寸'>
                        <div class="storeFlex">
                            <el-input size="mini" style="width: 90px" v-model="queryData.width" placeholder="请输入宽"></el-input>
                            <span style="color:#cbcbcb;width: 16px;height: 28px;line-height: 36px;">*</span>
                            <el-input size="mini" style="width: 80px" v-model="queryData.height" placeholder="请输入高"></el-input>
                        </div>
                    </CustomInput>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="mini" :loading="dataLoading" @click="handleSubmit">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="tool-bar mb10">
            <el-button type="primary" v-if="pageFuncNames.includes('add_size_rule')" @click="showAddModal"  size="mini" class="mr10">添加尺寸规则</el-button>
        </div>
        <div class="data-list">
            <jt-table
                v-loading="dataLoading"
                :data="dataList"
                stripe
                :header-cell-style="{background:'#e8eaec',color:'#333'}"
                :default-sort = "{prop: 'log_time', order: 'descending'}"
                style="width: 100%">
                <el-table-column
                    prop="id"
                    label="规则ID"
                    align="center"
                    min-width="100">
                </el-table-column>
                <el-table-column
                    prop="plat_id"
                    label="媒体"
                    align="center"
                    min-width="100">
                </el-table-column>
                <el-table-column
                    prop="type"
                    label="素材类型"
                    align="center"
                    min-width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type=='1'">图片</span>
                        <span v-else-if="scope.row.type=='2'">视频</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="delivery_scene_name"
                    label="投放场景"
                    align="center"
                    min-width="100">
                </el-table-column>
                <el-table-column
                    prop="delivery_type_name"
                    label="投放版位"
                    align="center"
                    min-width="100">
                </el-table-column>
                <el-table-column
                    prop="material_resolution"
                    label="素材尺寸"
                    align="center"
                    min-width="100">
                </el-table-column>
                <el-table-column
                    prop="user_name"
                    label="创建人"
                    align="center"
                    min-width="100">
                </el-table-column>
                <el-table-column
                    prop="ctime"
                    label="创建时间"
                    align="center"
                    min-width="100">
                    <template slot-scope="scope">
                        <p class="word-break">{{scope.row.ctime}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="edit_name"
                    label="最新修改人"
                    align="center"
                    min-width="100">
                </el-table-column>
                <el-table-column
                    prop="mtime"
                    label="最新修改时间"
                    align="center"
                    min-width="100">
                    <template slot-scope="scope">
                        <p class="word-break">{{scope.row.mtime}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="action"
                    label="操作"
                    align="center"
                    fixed="right"
                    min-width="100">
                    <template slot-scope="scope">
                        <el-button v-if="pageFuncNames.includes('edit_size_rule')" @click="editRow(scope.row)" type="text" class="text-color-primary mr10">编辑</el-button>
                        <el-popconfirm
                            title="您确定要删除吗？"
                            confirm-button-text="删除"
                            confirm-button-type="danger"
                            v-if="pageFuncNames.includes('delete_size_rule')"
                            @confirm="deleteRow(scope.row)">
                            <el-button slot="reference" :loading="scope.row.deleteLoading" type="text" class="text-color-error ml10">删除</el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </jt-table>

            <div class="page-bar tac mt20">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryData.pn"
                    :page-sizes="[30,50,100]"
                    :pager-count="5"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCnt">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import API from '@/api/workOrder/conf.js';
    import {sizeRuleModal} from '../modal/index';
    import CustomInput from '@/components/CustomInput'

    export default {
        name: "SizeList",
        props:{
            pageFunc:Array,
            platList:Array,
        },
        components:{
            CustomInput,
        },
        data(){
            return {
                dataLoading:false,
                queryData:{
                    id:'',
                    plat_id:'',
                    delivery_scene:'',
                    delivery_type:'',
                    width:'',
                    height:'',
                    pn: 1,
                    rn: 30,
                },
                dataList:[],
                totalCnt:0,
                ruleOptions:[],
                searchLoading:false,
                deliverySceneList:[],
                deliveryTypeList:[],
                deliverySceneLoading:false,
                deliveryTypeLoading:false,
            }
        },
        computed:{
            pageFuncNames(){
                return (this.pageFunc||[]).map(item=>item.name);
            },
        },
        mounted(){
            this.getDataList();
        },
        methods:{
            showAddModal(){
                console.log('showAddModal');
                sizeRuleModal({
                    props: {
                        platList:this.platList||[],
                    },
                    cbs:{
                        onSubmit:(page,viewChecked,editChecked)=>{
                            console.log('onSubmit：保存',page,viewChecked,editChecked);
                            this.getDataList();
                        },
                        onEdit:(id,list)=>{
                            this.toEditRow(id,list);
                        },
                    }
                })
            },
            getDataList(){
                console.log('getSizeConfigList');
                this.dataLoading = true;
                API.getSizeConfigList(this.queryData).then(res=>{
                    console.log('getSizeConfigList',res);
                    this.dataLoading = false;
                    let resData = res.data||{};
                    this.dataList = (resData.list||[]).map(item=>{
                        item.deleteLoading = false;
                        return item;
                    });
                    this.totalCnt = resData.totalCnt;
                },err=>{
                    console.log('getSizeConfigList err',err);
                    this.dataLoading = false;
                })
            },
            toEditRow(id,list){
                console.log('toEditRow',id,list);
                sizeRuleModal({
                    props: {
                        id:id,
                        platList:this.platList||[],
                        detail:list,
                    },
                    cbs:{
                        onSubmit:(data)=>{
                            console.log('onSubmit：保存',data);
                            this.getDataList();
                        },
                    }
                })
            },
            editRow(row){
                console.log('editRow',row);
                sizeRuleModal({
                    props: {
                        id:row.id,
                        platList:this.platList||[],
                    },
                    cbs:{
                        onSubmit:(data)=>{
                            console.log('onSubmit：保存',data);
                            this.getDataList();
                        },
                    }
                })
            },
            deleteRow(row){
                console.log('deleteRow',row);
                row.deleteLoading = true;
                API.deleteSizeConfig({
                    id:row.id,
                }).then(res=>{
                    this.$message.success(res.info||'操作成功');
                    this.getDataList();
                },err=>{
                    row.deleteLoading = false;
                    if (err.code == '403') {
                        this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$message.error(err.info||'操作失败');
                })
            },
            handleSizeChange(val) {
                this.queryData.rn= val;
                this.getDataList();
            },
            handleCurrentChange(val) {
                this.queryData.pn= val;
                this.getDataList();
            },
            getSearchList(query,filter){
                API.getSearchList({
                    query:query,
                }).then(res=>{
                    console.log('getSearchList',res);
                    this.ruleOptions = res.data||[];
                },err=>{
                    console.log('getSearchList err',err);
                    this.$message.error(err.info||'请求异常');
                    this.ruleOptions = [];
                })

            },
            changePlat(val){
                console.log('changePlat',val);
                this.getDeliverySceneOptions();
                this.queryData.delivery_scene = '';
                this.queryData.delivery_type = '';
                this.deliveryTypeList = [];
            },
            getDeliverySceneOptions(){
                this.deliverySceneLoading = true;
                API.getDeliveryOptions({
                    plat_id:this.queryData.plat_id,
                    search_type:'delivery_scene',     //delivery_scene投放场景 delivery_type投放版位
                }).then(res=>{
                    console.log('getDeliverySceneOptions',res);
                    this.deliverySceneLoading = false;
                    this.deliverySceneList = (res.data||[]).map(item=>{
                        return {
                            id:item.delivery_scene_id,
                            name:item.delivery_scene,
                        }
                    });
                },err=>{
                    console.log('getDeliverySceneOptions err',err);
                    this.deliverySceneLoading = false;
                    this.deliverySceneList = [];
                })
            },
            changeDeliveryScene(val){
                console.log('changeDeliveryScene',val);
                this.getDeliveryTypeOptions();
                this.queryData.delivery_type = '';
            },
            getDeliveryTypeOptions(){
                if(!this.queryData.delivery_scene) return;
                this.deliveryTypeLoading = true;
                API.getDeliveryOptions({
                    plat_id:this.queryData.plat_id,
                    search_type:'delivery_type',     //delivery_scene投放场景 delivery_type投放版位
                    delivery_scene_id:this.queryData.delivery_scene,
                }).then(res=>{
                    console.log('getDeliveryTypeOptions',res);
                    this.deliveryTypeLoading = false;
                    this.deliveryTypeList = (res.data||[]).map(item=>{
                        return {
                            id:item.delivery_type_id,
                            name:item.delivery_type,
                        }
                    });
                },err=>{
                    console.log('getDeliveryTypeOptions err',err);
                    this.deliveryTypeLoading = false;
                    this.deliveryTypeList = [];
                })
            },
            handleSubmit(){
                this.queryData.pn = 1;
                this.getDataList();
            },
            handleSelectAll(list, type, selectType,keyName) {
                if(selectType === 'all') {
                    const data = [...(this.queryData[type] || [])];
                    if(keyName){
                        data.push(...list.map(v=>v[keyName]));
                    }else{
                        data.push(...list.map(v=>v));
                    }

                    // 去重 赋值
                    this.queryData[type] = [ ...new Set(data)]
                }else{
                    let optionList_ids = [];
                    if(keyName){
                        optionList_ids = list.map(item=>item[keyName]);
                    }else{
                        optionList_ids = list.map(item=>item);
                    }

                    let channel_ids = this.queryData[type].filter(item=> !optionList_ids.includes(item));
                    this.queryData[type] = [...channel_ids];
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .storeFlex{
        display: inline-flex;
        width: 220px;
        align-items: center;
        overflow: hidden;
    }
    .word-break {
        word-break:break-word;
    }
</style>
